export const SET_ACTIVE_PACKAGE = 'SET_ACTIVE_PACKAGE'
export const setActivePackage = packageData => dispatch => {
  dispatch({
    type: SET_ACTIVE_PACKAGE,
    payload: packageData
  })
}

export const resetActivePackage = () => (dispatch, getState) => {
  const initialPackageKey = getState().initialPackage

  dispatch({
    type: SET_ACTIVE_PACKAGE,
    payload: initialPackageKey
  })
}
